import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export const useIsTouchDevice = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  if (!clientHasRendered) {
    return false;
  }
  return matchMedia('(hover: none)').matches;
};
